import moment from "moment/moment";
import { selectDateOrTime } from "./saleAnalysis-services";

export const selectTypes = [
  { id: 1, finalAcc: 1, name: "mezania", label: "balance-sheet" },
  { id: 2, finalAcc: 2, name: "arbah", label: "profit-loss" },
  { id: 3, finalAcc: -1, name: "", label: "trial-balance" },
];

export const levelOptions = [
  { id: -1, label: "all", type: -1 },
  { id: 1, label: "1", type: 1 },
  { id: 2, label: "2", type: 1 },
  { id: 3, label: "3", type: 1 },
  { id: 4, label: "4", type: 2 },
];
export const typeCostOptions = [
  { name: "average_cost_price", id: 1 },
  { name: "last-purchase-price", id: 2 },
  { name: "last-supply-price", id: 3 },
  { name: "item-purchase-price", id: 4 },
];
export const aMdefaultValues = {
  dateFrom: moment(new Date()).subtract(6, "month").format("YYYY-MM-DD"),
  dateTo: moment(new Date()).format("YYYY-MM-DD"),
  branch: { id: -1, name: "all" },
  center: { id: -1, name: "all" },
  level: levelOptions[4],
  type: selectTypes[0],
  chk_Prev: true,
  chkPrev: true,
  type_cost: typeCostOptions[0],
  no_stock: true,
  acc_type: 0,
};


export const SearchActivityReports = {
  dateFrom: moment(new Date()).format('YYYY-MM-DD'),
  timeFrom: moment(new Date()).format('HH:mm'),
  dateTo: moment(new Date()).format('YYYY-MM-DD'),
  timeTo: moment(new Date()).format('HH:mm'),
  safe: { id: -1, name: "all" },
  user:{ id: -1, name: "all" },
  type: 1,
  branch:{ id: -1, name: "all" },
  IdCom: -1,
  sProTyInvPro:"02",
  curr: {id:-1, name:''},
  selectTime:selectDateOrTime[0],
};
export const excelHeaders = [
  { label: "forms:account-code", key: "ac" },
  { label: "forms:account", key: "AName" },
  { label: "forms:debit-opening", key: "val_open_dept" },
  { label: "forms:credit-opening", key: "val_open_credit" },
  { label: "forms:prev-debit-balance", key: "OB_DR_AMT_L" },
  { label: "forms:prev-credit-balance", key: "OB_CR_AMT_L" },
  { label: "forms:debit-movement", key: "DR_AMT_L" },
  { label: "forms:credit-movement", key: "CR_AMT_L" },
  { label: "forms:balance-debit", key: "End_DR_AMT_L" },
  { label: "forms:balance-credit", key: "End_CR_AMT_L" },
];
